import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const ApmcPending = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
  
      
 
   const statusOptions = [
          { value: "all_pending", label: "All Applications" , role:["JC" , "COM" , "Dr","SC" ,"HOS" , "DY", "DT", "SA"] },
        { value: "pendingAtDClerk", label: "Pending with Dist. Clerk" , role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT", "SA"] },
        { value: "returnToDClerkForwardingToHO", label: "Pending with Dist. Clerk for forwarding to HO" ,  role:[ "JC" ] },
        { value: "pendingAtCOM", label: "Pending with Dist. Cooperative Officer Marketing" , role:[ "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtDR", label: "Pending with Dist. Registrar" , role:["Dr", "SC" , "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtHOClerk", label: "Pending with HO Clerk", role:[ "SC" , "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHoOS", label: "Pending with Ofc. superintendent" , role:["HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHoDY", label: "Pending with Dpy. Director" , role:[ "DY", "DT","SA"] },
        { value: "pendingAtHoDT", label: "Pending with Director" ,  role:[ "DT","SA" ] },
        { value: "pendingAtdClerkResubmission", label: "Pending Resubmission with Dist. Clerk   " , role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },

                        { value: "pendingAtdClerkAfterApmcHOResubmission", label: "Pending Resubmission with Dist. Clerk after apmc HO resubmission " , role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                 { value: "pendingAtCOMAfterApmcHOResubmission", label: "Pending Resubmission with Dist. Cooperative Officer Marketing after apmc HO resubmission " , role:[ "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                      { value: "pendingAtDrAfterApmcHOResubmission", label: "Pending Resubmission with Dist. Registrar after apmc HO resubmission " , role:[ "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                       { value: "pendingAtdClerkAfterApmcHOResubmissionAfterHARQ", label: "Pending Resubmission with Dist. Clerk after apmc Higher Authority resubmission " , role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                 { value: "pendingAtCOMAfterApmcHOResubmissionAfterHARQ", label: "Pending Resubmission with Dist. Cooperative Officer Marketing after apmc Higher Authority resubmission " , role:[ "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                      { value: "pendingAtDrAfterApmcHOResubmissionAfterHARejectionAction", label: "Pending Resubmission with Dist. Registrar after apmc Higher Authority resubmission " , role:[ "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
                      { value: "returnToDClerkForwardingToHOResubmission", label: "Pending  Resubmission with Dist. Clerk for forwarding to HO after apmc resubmission ",  role:[ "JC" ] },
          { value: "returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ", label: "Pending  Resubmission with Dist. Clerk for forwarding to HO after apmc Higher Authority resubmission " ,  role:[ "JC" ] },
        { value: "pendingAtCoResubmission", label: "Pending Resubmission with Dist. Cooperative Officer Marketing " , role:[ "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtDrResubmission", label: "Pending Resubmission with Dist. Registrar ", role:[ "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
              { value: "returnToDClerkAfterApmcForwardingToHOResubmission", label: "Pending  Resubmission with Dist. Clerk for forwarding to HO after apmc Ho resubmission " ,  role:[ "JC" ] },
        { value: "pendingAtHOClerkResubmission", label: "Pending Resubmission with HO Clerk after apmc resubmission " , role:["SC" , "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtHOOSResubmission", label: "Pending Resubmission with Ofc. superintendent after apmc resubmission " , role:[ "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHODYResubmission", label: "Pending Resubmission with Dpy. Director after apmc resubmission " , role:[  "DY", "DT","SA"]},
        { value: "pendingAtHODTResubmission", label: "Pending Resubmission with Director after apmc resubmission " , role:["DT","SA"] },
        { value: "pendingAtHOClerkResubmissionAfterHARQ", label: "Pending Resubmission with HO Clerk after  Higher Authority apmc resubmission " , role:["SC" , "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtHOOSResubmissionAfterHARQ", label: "Pending Resubmission with Ofc. superintendent after  Higher Authority apmc resubmission " , role:[ "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHODYResubmissionAfterHARQ", label: "Pending Resubmission with Dpy. Director after  Higher Authority apmc resubmission " , role:[  "DY", "DT","SA"]},
        { value: "pendingAtHODTResubmissionAfterHARQ", label: "Pending Resubmission with Director after  Higher Authority apmc resubmission  " , role:["DT","SA"] },
      ];
    const rolePriorityMap: Record<string, string> = {
        JC: "all_pending",
        COM: "all_pending",
        Dr: "all_pending",
        SC:"all_pending",
        HOS:"all_pending",
        DY:"all_pending",
        DT:"all_pending",

      };

      // Filter options for current role
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));

      const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0].value;
      
      // Reorder the options to place the matched option first
      const reorderedStatusOptions = [
        filteredOptions.find(option => option.value === firstOptionValue),
        ...filteredOptions.filter(option => option.value !== firstOptionValue)
      ].filter(Boolean); 
   


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default ApmcPending;
